// extracted by mini-css-extract-plugin
export default {"collapseContainer":"Collapse_collapseContainer__EhzN0","collapseButton":"Collapse_collapseButton__m316K","collapseContent":"Collapse_collapseContent__3oZcc"};